import { render, staticRenderFns } from "./SortableTd.vue?vue&type=template&id=59368612&"
import script from "./SortableTd.vue?vue&type=script&lang=ts&"
export * from "./SortableTd.vue?vue&type=script&lang=ts&"
import style0 from "./SortableTd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports